import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { PaperPlaneTilt } from '@phosphor-icons/react';
import client from '../../api/client';
import AppIcon from '../AppIcon';
import MessageLog from './MessageLog';

export const SentMessagesPanel = ({ onSeen }) => {
  const [alerts, setAlerts] = useState(null);
  useEffect(() => {
    client.get('/message-log/alerts').then(({ data }) => {
      setAlerts(data);
      if (data.unseen) client.post('/message-log/alerts/seen').then(() => onSeen?.()).catch(() => {});
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section data-testid="sent-messages-panel" className="soft-card rounded-2xl p-5 bg-white border border-[#EFE3D8] mb-6">
      <div className="flex items-center gap-3 mb-4">
        <AppIcon icon={PaperPlaneTilt} tone="sky" size="md" reveal />
        <div>
          <h3 className="font-serif text-xl text-[#2A2A2A]">Sent messages</h3>
          <p className="text-xs text-[#6A6A6A]">Every text and email sent to guests: who, where, what, when, and whether it arrived. Tap a row to read the message.</p>
        </div>
      </div>
      {alerts?.unseen > 0 && (
        <div data-testid="message-failure-alert" className="mb-4 rounded-xl border border-[#F8C3D3] bg-[#FFF5F8] p-3 text-sm">
          <p className="font-medium text-[#B4235A] inline-flex items-center gap-1.5"><AlertTriangle className="w-4 h-4" /> {alerts.unseen} message{alerts.unseen === 1 ? '' : 's'} didn&apos;t go through since you last checked</p>
          <ul className="mt-1.5 space-y-0.5 text-xs text-[#4A4A4A]">
            {alerts.latest.map((m) => <li key={m.id}><strong className="font-medium">{m.guest_name}</strong> ({m.kind_label}): {m.error || m.delivery}</li>)}
          </ul>
        </div>
      )}
      <MessageLog initialStatus={alerts?.unseen ? 'problem' : ''} key={alerts ? 'ready' : 'loading'} />
    </section>
  );
};

export default SentMessagesPanel;
